export default __webpack_public_path__ + "static/media/xButton-disabled.ed8f03bf.svg";